var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "17.657 7.757 13.414 12 17.657 16.243 16.243 17.657 12 13.414 7.757 17.657 6.343 16.243 10.586 12 6.343 7.757 7.757 6.343 12 10.586 16.243 6.343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchReset);
export default __webpack_public_path__ + "static/media/search-reset.5fbe5f64e7afa9820ae85705a66c0b86.svg";
export { ForwardRef as ReactComponent };